import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../../lib/api';

export const inspectionsKey = (params) => ['reports', 'inspections', params || {}];
export const inspectionDetailsKey = (ts, params) => ['reports', 'inspections', ts, 'details', params || {}];
export const inspectionAnalyticsKey = (ts, params) => ['reports', 'inspections', ts, 'analytics', params || {}];

function qs(params) {
  const q = new URLSearchParams();
  if (params.industry_id)    q.set('industry_id', params.industry_id);
  if (params.project_id)     q.set('project_id', params.project_id);
  if (params.deliverable_id) q.set('deliverable_id', params.deliverable_id);
  return q.toString();
}

/** List the timestamp folders that exist in S3 for the chosen filters. */
export function useInspectionTimestamps(params = {}, { enabled = true } = {}) {
  const search = qs(params);
  return useQuery({
    queryKey: inspectionsKey(params),
    queryFn: () => apiGet(`/reports/inspections${search ? `?${search}` : ''}`),
    enabled,
  });
}

/** Fetch reports.json for one inspection. Image paths are already presigned. */
export function useInspectionDetails(timestamp, params = {}, { enabled = true } = {}) {
  const search = qs(params);
  return useQuery({
    queryKey: inspectionDetailsKey(timestamp, params),
    queryFn: () => apiGet(`/reports/inspections/${encodeURIComponent(timestamp)}/details?${search}`),
    enabled: Boolean(enabled && timestamp),
  });
}

/** Fetch analytics.json for one inspection (charts data). */
export function useInspectionAnalytics(timestamp, params = {}, { enabled = true } = {}) {
  const search = qs(params);
  return useQuery({
    queryKey: inspectionAnalyticsKey(timestamp, params),
    queryFn: () => apiGet(`/reports/inspections/${encodeURIComponent(timestamp)}/analytics?${search}`),
    enabled: Boolean(enabled && timestamp),
  });
}

/** Resolve a presigned URL for the inspection's report.pdf. */
export async function getInspectionReportPdfUrl(timestamp, { industry_id, project_id, deliverable_id }) {
  const r = await apiGet(
    `/reports/inspections/${encodeURIComponent(timestamp)}/report-pdf-url?` +
    qs({ industry_id, project_id, deliverable_id }),
  );
  return r;
}
